import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type DualPathCtaProps = CtaShellProps

export function DualPathCta(props: DualPathCtaProps) {
	return <CtaShell {...props} layout="dual-path" />
}